document.addEventListener("DOMContentLoaded", function () {
  let s, t;

  function handleScroll() {
    t = window.scrollY;

    document.querySelectorAll(".fadein").forEach(function (element) {
      if (s <= 749) { 
        const rect = element.getBoundingClientRect();
        const o = rect.top;

        if (o < window.innerHeight && !element.classList.contains("on")) {
          element.classList.add("on");
        } else if (o > window.innerHeight && element.classList.contains("on")) {
          element.classList.remove("on");
        }
      } else { 
        const o = element.getBoundingClientRect().top + window.scrollY;
        let n = 0.9;
        const i = t + window.innerHeight * n;
        const n2 = t + 1.5 * window.innerHeight;

        if (o < i && !element.classList.contains("on")) {
          element.classList.add("on");
        } else if (n2 < o && element.classList.contains("on")) {
          element.classList.remove("on");
        }
      }
    });

    document.querySelectorAll(".fade").forEach(function (element) {
      if (s > 749) { 
        const o = element.getBoundingClientRect().top + window.scrollY;
        let n = 0.9;
        const i = t + window.innerHeight * n;
        const n2 = t + 1.5 * window.innerHeight;

        if (o < i && !element.classList.contains("on")) {
          element.classList.add("on");
        } else if (n2 < o && element.classList.contains("on")) {
          element.classList.remove("on");
        }
      } else { 
        const rect = element.getBoundingClientRect();
        const o = rect.top;

        if (o < window.innerHeight && !element.classList.contains("on")) {
          element.classList.add("on");
        } else if (o > window.innerHeight && element.classList.contains("on")) {
          element.classList.remove("on");
        }
      }
    });
  }

  function handleResize() {
    s = window.innerWidth;
    slider_set(s);
  }

  handleScroll();
  handleResize();

  window.addEventListener("load", handleScroll);
  window.addEventListener("scroll", handleScroll);
  window.addEventListener("resize", handleResize);
});

function slider_set(width) {
  console.log("Slider set with width:", width);
}